<template>
  <div class="form-group  row">
    <label style="font-weight: bold">{{name}}</label>
    <input type="text" class="form-control m-input" :placeholder="placeholder" :value="value"

           @input="update( $event.target.value)">
  </div>
</template>

<script>
export default {
name: "ControlLibraryInput",
  props: [
    "name", "value" ,"field" ,"placeholder"
  ],
  methods: {
    update(content) {
      this.$emit('update', {field: this.field, value: content})
    }
  }
}
</script>

<style scoped>

</style>
